import React from 'react'
import {Container, Grid, Header, Dropdown} from "semantic-ui-react";
import Footer from "../components/Footer";
import {classOptions} from "../Options/ClassLevelOptions";

function Home(
    {
        handleClassLevel,
        classLevel
    }
) {

    return (
        <>
            <Grid className='center aligned' style={{marginTop: 10}}>

                <Grid.Row>
                    <Header as='h1' color='green'>Welcome to the University of Hawaiʻi at Mānoa Samoan Language
                        Practice Site
                    </Header>
                </Grid.Row>

                <Grid.Row>
                    <Header as='h3' color='blue'>Choose your class below, then click on the menu above to start
                        practice</Header>
                </Grid.Row>

                <Grid.Row>
                    <Dropdown
                        options={classOptions}
                        selection
                        onChange={handleClassLevel}
                        placeholder='Samoan 101'
                        value={classLevel}
                    />
                </Grid.Row>

                <Footer/>

                <Container>
                    <Grid.Row style={{minHeight: 150, marginTop: 50}}>
                        <Header as='h4' style={{ left: 0, bottom: 0}}>Copyright (C) August 24,
                            2020 - Department of Indo-Pacific Languages and Literature, University of Hawaiʻi at
                            Mānoa.
                            Except as permitted by applicable copyright law, you may not reproduce or communicate
                            any of the content on this website, including files downloadable from this website,
                            without the permission of the copyright owner.

                            Content provided by Faʻafetai Lesā, Edward Danielson, John Mayer, Department of
                            Indo-Pacific Languages and Literature, University of Hawaiʻi at Mānoa.
                            Website designed and developed by <a href='https://tabalbar.github.io' target="_blank">Roderick
                                Tabalba</a> & Jason Leigh, Department of Information and Computer Sciences,
                            University of Hawaiʻi at Mānoa.</Header>
                    </Grid.Row>
                </Container>
            </Grid>
        </>
    )
}

export default Home
